/* MAIN */
const once = (fn) => {
    let called = false;
    let result;
    return () => {
        if (!called) {
            called = true;
            result = fn();
        }
        return result;
    };
};
/* EXPORT */
export default once;
